import {Model} from '@/models/Model';
import {Size} from '@/models/Size';
import {cloneDeep} from "lodash";
import ErrorHandler from "@/support/ErrorHandler";

export class SupplierSize extends Model {
  protected $name: string = 'SupplierSize';

  protected $endpoint: string = '/supplier-sizes';

  protected $fillable: string[] = [
    'name',
    'size_id',
    'sort_column',
    'default_order_quantity',
  ];

  protected $includes: SupplierSizeIncludeType[] = [];

  public id?: string;
  public name?: string;
  public size?: Size;
  public size_id?: string;
  public sort_column?: number;
  public default_order_quantity?: number;

  public include(includes: SupplierSizeIncludeType | SupplierSizeIncludeType[]): this {
    return super.include.call(this, includes);
  }

  protected static instance?: SupplierSize;

  public static getInstance(instance: SupplierSize) {
    if (!this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }

  public async autocomplete() {
    if (!this.initialCallResult) {
      this.initialCallResult = SupplierSize.getAllItems();
    }

    if (this.initialCallResult instanceof Promise) {
      return await this.initialCallResult;
    }

    return this.initialCallResult;
  }

  private static async getAllItems() {
    let items: SupplierSize[] = [];

    try {
      items = await cloneDeep(new SupplierSize())
        .limit(999)
        .all();
    } catch (error) {
      ErrorHandler.network(error);
    }

    while (SupplierSize.getHasNextPage(items)) {
      try {
        const newItems = await cloneDeep(items[items.length - 1] as Model)
          .page((items[items.length - 1] as any).meta.current_page + 1)
          .all();
        items = [...items, ...newItems];
      } catch (error) {
        ErrorHandler.network(error);
      }
    }

    return items;
  }


  private static getHasNextPage(items: SupplierSize[]): boolean {
    if (!items.length) {
      return false;
    }

    const lastInternalItem = items[items.length - 1] as {
      meta?: {
        last_page?: number;
        current_page?: number;
      }
    };

    if (
      !lastInternalItem.meta
      || !lastInternalItem.meta.last_page
      || !lastInternalItem.meta.current_page
      || lastInternalItem.meta.current_page === lastInternalItem.meta.last_page
    ) {
      return false;
    }

    return true;
  }
}


export type SupplierSizeIncludeType = 'size';
